module.exports = "<google-chart id=\"googlechartIndex\" [data]=\"pieChartData\" #googlechartIndex></google-chart>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/charts/chart-pie/chart-pie.component.html
// module id = ./src/app/shared/charts/chart-pie/chart-pie.component.html
// module chunks = main